import { render, staticRenderFns } from "./GalaxyStaffView.vue?vue&type=template&id=a9266f22&scoped=true&"
import script from "./GalaxyStaffView.vue?vue&type=script&lang=js&"
export * from "./GalaxyStaffView.vue?vue&type=script&lang=js&"
import style0 from "./GalaxyStaffView.vue?vue&type=style&index=0&id=a9266f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9266f22",
  null
  
)

export default component.exports